<template>
  <div class="bg-white border p-2 mt-3">
    <div class="table-responsive position-relative"
      :class="{ 'with-actions-gap': companies.length < 4, 'opacity-50': loading }">
      <table class="table">
        <caption class="sr-only" data-no-export>{{ i18n('Company list') }}</caption>
        <thead>
          <tr class="d-none d-lg-table-row">
            <th class="text-nowrap" scope="col">{{ i18n('Id') }}</th>
            <th class="text-nowrap" scope="col">{{ i18n('Code') }}</th>
            <th class="text-nowrap" scope="col">{{ i18n('Alias') }}</th>
            <th class="text-nowrap" scope="col">{{ i18n('Name') }}</th>
            <th class="text-nowrap" scope="col">{{ i18n('Of Group') }}</th>
            <th class="text-nowrap" scope="col">{{ i18n('Client') }}</th>
            <th class="text-nowrap" scope="col">{{ i18n('Users') }}</th>
            <th class="text-nowrap" scope="col">{{ i18n('Created At') }}</th>
            <th data-no-export scope="col" style="min-width: 48px">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <CompanyListItem v-for="company in companies" :company="company" :key="company.id"
            @deleted="$emit('deleted', $event)" @updated="$emit('updated', $event)"
            @updating="$emit('updating', $event)" />
          <EmptyListItem v-if="!companies || companies.length == 0" :loading="loading" :colspan="5" />
          <LazyLoadListItem v-if="!loading && (lazyLoad || autoLazyLoad)"
            :autoLazyLoad="!pagination.singlePage && autoLazyLoad" :colspan="5" @next="$emit('next', $event)" />
        </tbody>
      </table>
      <div class="position-absolute h-100 w-100 top-0" @click.stop v-if="loading"></div>
    </div>
    <Pagination cssClass="mt-2" v-if="pagination && pagination.singlePage && pagination.limit < pagination.total"
      :pagination="pagination" :loading="loading" @goToPage="(...args) => $emit('goToPage', ...args)" />
  </div>
</template>

<script>
import CompanyListItem from "@/components/company/CompanyListItem.vue";
import EmptyListItem from "@/components/common/list/EmptyListItem.vue";
import LazyLoadListItem from "@/components/common/list/LazyLoadListItem.vue";
import Pagination from "@/components/common/list/Pagination.vue";
import Tooltip from "@/components/common/layout/Tooltip.vue";

export default {
  components: {
    CompanyListItem,
    EmptyListItem,
    LazyLoadListItem,
    Pagination,
    Tooltip,
  },
  emits: [
    'updated',
    'deleted',
    'updated',
    'updating',
    'next',
    'goToPage',
  ],
  props: {
    loading: Boolean,
    lazyLoad: Boolean,
    autoLazyLoad: Boolean,
    pagination: Object,
    companies: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
  },
};
</script>